import { memo, useCallback, useEffect } from 'react';
import type { ICustomSearchScenario as ICmsScenario } from '@/api/cms/searchScenario';
import type { GameV1 } from '@/api/games';
import { GamesGrid } from '@/components/GamesGrid';
import { formatDescriptionV2Html } from '../../../../../../../seo/content/shared';
import type { ISearchFallbackScenariosProps } from '..';
import { ScSearchFallbackScenario } from '../styled';

interface ICustomScenarioProps extends ISearchFallbackScenariosProps {
  scenario: ICmsScenario;
}

export const CustomScenario = memo(
  ({
    scenario,
    sendSearchResultAppearance,
    handleSearchGameClick,
    gridOptions,
    closeModal,
  }: ICustomScenarioProps) => {
    useEffect(() => {
      sendSearchResultAppearance({ status: 'custom' });
    }, []);

    const handleClick = useCallback(
      (game: GameV1) => handleSearchGameClick(game, 'search_results'),
      [handleSearchGameClick]
    );

    const handleLinkClick = useCallback(
      (e: React.MouseEvent<HTMLDivElement>) => {
        if ((e.target as HTMLElement).closest('a')) closeModal?.();
      },
      [closeModal]
    );

    const formattedHtml = formatDescriptionV2Html(scenario.customText);

    return (
      <ScSearchFallbackScenario>
        {formattedHtml && (
          <div
            className="text"
            dangerouslySetInnerHTML={{
              __html: formattedHtml,
            }}
            onClick={handleLinkClick}
          />
        )}

        {(scenario?.gameCategoryId || scenario?.providerId) && (
          <GamesGrid
            category={scenario?.gameCategoryId}
            provider={scenario?.providerId}
            {...gridOptions}
            onDemoClick={handleClick}
            onPlayClick={handleClick}
          />
        )}
      </ScSearchFallbackScenario>
    );
  }
);
